import { ref, onValue, update, remove } from "firebase/database";
import database from "../firebase";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import style1 from "../stylees/Get_patients.module.css";
import style from "../stylees/add.module.css";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Edit from "./Edit";
import { MdDeleteForever } from "react-icons/md";
function GetPatients() {
  const myroute = useLocation().pathname;
  const [patients, setPatients] = useState([]);
  const [custom_date, setCustom_date] = useState(
    new Date().toLocaleDateString("en-GB").split("/").reverse().join("-")
  );
  let [loader, setLoader] = useState(true);
  let [examinationTime, setExaminationTime] = useState("");
  useEffect(() => {
    const patientsRef = ref(database, "patients");
    const unsubscribe = onValue(
      
      patientsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = Object.entries(data).map(([id, values]) => ({
            id,
            ...values,
          }));
          const filteredData = formattedData.filter(
            (item) => item.date === custom_date
          );
          // handle sound
          if (JSON.stringify(filteredData) !== JSON.stringify(patients)) {
      
            // Play sound when any change is detected
            const audio = new Audio("/messageSound.mp3");
            audio.play().catch((error) =>
              console.error("Error playing sound:", error)
            );
          }
          setPatients(filteredData);
          setLoader(false);
        } else {
          setPatients([]);
        }
      },
      (error) => {
        setLoader(false);
        console.error("Error fetching real-time patients:", error);
      }
    );
    return () => unsubscribe();
  }, [myroute, custom_date]);
  // update patient state
  const handleStateChange = (id, newState) => {
    const patientRef = ref(database, `patients/${id}`);
    update(patientRef, { state: newState })
      .then(() => {
        console.log(`Patient ${id} state updated to ${newState}`);
      })
      .catch((error) => {
        console.error("Error updating patient state:", error);
      });
  };
  // update injection time
  const handleInjectionChange = (id) => {
    const patientRef = ref(database, `patients/${id}`);
    update(patientRef, { injection: getCurrentTimeWithoutSeconds() })
      .then(() => {
        console.log(`Patient ${id} injection time updated`);
      })
      .catch((error) => {
        console.error("Error updating patient injection time:", error);
      });
  };
  // update asqcition time
  const handleExaminationChange = (id) => {
    const patientRef = ref(database, `patients/${id}`);
    update(patientRef, { Examination: examinationTime })
      .then(() => {
        console.log(`Patient ${id} asqcitionExamination  time updated `);
      })
      .catch((error) => {
        console.error("Error updating Examination  injection time:", error);
      });
  };
  // delete patient
  const handleDelete = (id) => {
    const patientRef = ref(database, `patients/${id}`);
    remove(patientRef)
      .then(() => {
        console.log(`Patient ${id} deleted successfully.`);
        setPatients((prevPatients) =>
          prevPatients.filter((patient) => patient.id !== id)
        ); // Update local state
      })
      .catch((error) => {
        console.error("Error deleting patient:", error);
      });
  };
  // get current time
  function getCurrentTimeWithoutSeconds() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  // Row color
  const getRowClass = (state) => {
    switch (state) {
      case "Arrived":
        return "table-primary";
      case "Injected":
        return "table-success";
      case "Imaging":
        return "table-warning";
      case "Completed":
        return "table-danger";
        case "Review":
          return style1.review;
      default:
        return "";
    }
  };
  // Download Excel
  const downloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Patients");
    // Add a simple title row for the hospital header
    worksheet.addRow(["King Fahd Specialist Hospital"]);
    worksheet.addRow([]); // Empty row for spacing
    worksheet.addRow([`Date: ${custom_date}`]); // Date row
    worksheet.addRow([]); // Empty row for spacing
    // Add headers
    const headers = [
      "Name",
      "File No",
      "Gender",
      "Doctor",
      "Procedure",
      "History",
      "Injection time",
      "Examination time",
      "State",
      "note",
      "Ward",
    ];
    const headerRow = worksheet.addRow(headers);
    worksheet.addRow([]); // Empty row for spacing
    // Style the header row (Primary Color)
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "#FF78D4" }, // Primary color (blue)
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Add patient data
    if (Array.isArray(patients) && patients.length > 0) {
      patients.forEach((patient) => {
        worksheet.addRow([
          patient.name,
          patient.fileNo,
          patient.gender,
          patient.doctor,
          patient.procedure,
          patient.history,
          patient.injection,
          patient.Examination,
          patient.state,
          patient.note,
          patient.ward,
        ]);
      });
    } else {
      console.error("No patient data found.");
    }
    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `Patients_${custom_date}.xlsx`);
    });
  };
  return (
    <div>
{/* spineer && loader */}
      {loader && (
        <div className={style1.loader}>
          <div>loading....</div>
        </div>
      )}
      <div className="container-fluid d-flex justify-content-end mb-2">
        {/* dateinput of specific date to display patients //?-> his default value is the current date */}
        <div className="me-3">
          <input
            className={`form-control ${style.inputChange}`}
            type="date"
            name="specificDate"
            id="date"
            value={custom_date}
            onChange={(e) => setCustom_date(e.target.value)}
          />
        </div>
        {/* Dowload Excel button for patientsManagement page only */}
        {myroute === "/controls" && (
          <button
            className="btn btn-warning fw-bold text-white"
            onClick={downloadExcel}
          >
            Download
          </button>
        )}
      </div>
      {/* the table section of patients */}
      <section className="container-fluid overflow-x-scroll">
        <table
          className="table table-light text-white fs-5  rounded-3 overflow-hidden shadow shadow-sm"
          style={{ minWidth:"100%" }}
        >
          <thead>
            <tr
            >
              <th className="bg-info text-white py-3 px-2 ">#</th>
              <th className="bg-info text-white py-3 px-2">Name</th>
              <th className="bg-info text-white py-3 px-2">File No</th>
              <th className="bg-info text-white py-3 px-2">Gender</th>
              <th className="bg-info text-white py-3 px-2">Doctor</th>
              <th className="bg-info text-white py-3 px-2">Procedure</th>
              <th className="bg-info text-white py-3 px-2">History</th>
              <th className="bg-info text-white py-3 px-2">Injection time</th>
              <th className="bg-info text-white py-3 px-2">Examination time</th>
              <th className="bg-info text-white py-3 px-2">State</th>
              <th className="bg-info text-white py-3 px-2">Ward</th>
              <th className="bg-info text-white py-3 px-2">Note</th>
              {myroute === "/controls" && (
                <th className="bg-info text-white py-3 px-2">Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {patients.map((patient, index) => (
              <>
                {/* Main Row */}
                <tr key={patient.id} className={getRowClass(patient.state)}>
                  <td  className={getRowClass(patient.state)}>{index + 1}</td>
                  <td  className={getRowClass(patient.state)}>{patient.name}</td>
                  <td  className={getRowClass(patient.state)}>{patient.fileNo}</td>
                  <td  className={getRowClass(patient.state)}  >{patient.gender}</td>
                  <td  className={getRowClass(patient.state)}>{patient.doctor}</td>
                  <td  className={getRowClass(patient.state)}>{patient.procedure}</td>
                  <td  className={getRowClass(patient.state)}>{patient.history}</td>
                 {/* injection management */}
                  <td  className={getRowClass(patient.state)}>
                    {myroute === "/controls" && patient.injection === "-" ? (
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleInjectionChange(patient.id)}
                      >
                        ADD
                      </button>
                    ) : (
                      patient.injection
                    )}
                  </td>
                   {/* examination management */}
                  <td  className={getRowClass(patient.state)}>
                    {/* to do change Examination  */}
                    {myroute === "/controls" && patient.Examination === "-" ? (
                      <>
                        <form
                          className="d-flex align-items-center"
                          onSubmit={() => handleExaminationChange(patient.id)}
                        >
                          <input
                            type="time"
                            class={`form-control w-auto me-1  ${style.time_input}`}
                            id="timeInput"
                            onChange={(e) => setExaminationTime(e.target.value)}
                            required
                          />
                          <button className="btn btn-primary btn-sm">
                            ADD
                          </button>
                        </form>
                    
                      </>
                    ) : (
                      patient.Examination
                    )}
                  </td>
                  {/* state management */}
                  {myroute === "/controls" && (
                    <td  className={getRowClass(patient.state)}>
                      <select
                        className="form-select w-auto"
                        onChange={(e) =>
                          handleStateChange(patient.id, e.target.value)
                        }
                        value={patient.state || ""}
                      >
                        <option value="" disabled>
                          Change state
                        </option>
                        <option value="waiting">waiting</option>
                        <option value="Arrived">Arrived</option>
                        <option value="Injected">Injected</option>
                        <option value="Imaging">Imaging</option>
                        <option value="Review">Review</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </td>
                  )}
                  {myroute === "/display" && <td  className={getRowClass(patient.state)}>{patient.state}</td>}
                  <td  className={getRowClass(patient.state)}>{patient.ward}</td>
                  <td  className={getRowClass(patient.state)}>{patient.note}</td>
                  {/* Action management */}
                  {myroute === "/controls" && (
                    <td  className={getRowClass(patient.state)}>
                     <div className="d-flex align-items-center">
                      <button className="btn btn-outline-danger btn-sm me-1" onClick={() => handleDelete(patient.id)}><  MdDeleteForever className="fs-4"/>
                      </button>
                      <Edit patient={patient} />
                     </div>
                    </td>
                  )}
                </tr>
                {/* Note Row */}
                {/* <tr key={patient.id + "-details"} className={getRowClass(patient.state)}>
      <td  className={getRowClass(patient.state)}colSpan="10" className="note-row text-center">
       {patient.details || "No additional details available."}
      </td>
    </tr> */}
              </>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}

export default GetPatients;
